  function calc() {
    const length = parseFloat(document.volcalc.length.value) || 0;
    const width = parseFloat(document.volcalc.width.value) || 0;
    const depth = parseFloat(document.volcalc.depth.value) || 0;
    const material = document.querySelector('input[name="material_calculator"]:checked')?.value || null;
    const totalLabel = document.getElementById('total-label');
    const totalField = document.volcalc.vol;
    const rockNotice = document.getElementById('rock-depth-notice');
    const errorMsg = document.getElementById('material-error');

    // Reset error message visibility
    errorMsg.style.display = "none";

    // If user entered dimensions but didn't pick a material
    if ((length || width || depth) && !material) {
      totalLabel.textContent = "Amount Needed";
      totalLabel.classList.add('disabled-label');
      totalField.value = "";
      totalField.disabled = true;
      errorMsg.style.display = "block"; // show error
      rockNotice.classList.remove('show');
      return;
    }

    // If material selected, hide error
    errorMsg.style.display = "none";

    // Adjust label and notice based on material type
    if (material === "1.5") {
      totalLabel.textContent = "Tons Needed:";
      totalLabel.classList.remove('disabled-label');
      rockNotice.classList.add('show');
      totalField.disabled = false;
    } else if (material === "1") {
      totalLabel.textContent = "Cubic Yards Needed:";
      totalLabel.classList.remove('disabled-label');
      rockNotice.classList.remove('show');
      totalField.disabled = false;
    } else {
      totalLabel.textContent = "Amount Needed";
      totalLabel.classList.add('disabled-label');
      rockNotice.classList.remove('show');
      totalField.value = "";
      totalField.disabled = true;
      return;
    }

    // Convert to yards
    const l = length / 3;
    const w = width / 3;
    const d = depth / 36;

    // Calculate total volume
    let v = l * w * d * material;
    v = Math.round(v * 100) / 100; // round to 2 decimals

    totalField.value = v;
  }

  function clearForm() {
    // Clear text fields
    document.volcalc.length.value = "";
    document.volcalc.width.value = "";
    document.volcalc.depth.value = "";
    document.volcalc.vol.value = "";

    // Uncheck radio buttons
    document.querySelectorAll('input[name="material_calculator"]').forEach(r => r.checked = false);

    // Reset label and disable total field
    const totalLabel = document.getElementById('total-label');
    const totalField = document.volcalc.vol;
    totalLabel.textContent = "Amount Needed";
    totalLabel.classList.add('disabled-label');
    totalField.disabled = true;

    // Hide messages and notices
    document.getElementById('material-error').style.display = "none";
    document.getElementById('rock-depth-notice').classList.remove('show');
  }

  // Add event listeners when the page loads
  window.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.field, input[name="material_calculator"]').forEach(el => {
      el.addEventListener('input', calc);
      el.addEventListener('change', calc);
    });
    document.getElementById('clear-btn').addEventListener('click', clearForm);
  });
